module.exports = "/_next/static/images/Hero@2x-9ad35879be16a36e8d9c7969ab016dc7.png";